import {
    BILLING_ADDRESSES,
    BILLING_ADDRESSES_SUCCESS,
    BILLING_ADDRESSES_FAILURE,
} from '../actions/action-types';

/**
 * initial state
 */
const INIT_STATE = {
    data: null,
    error: null,
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case BILLING_ADDRESSES:
            return { ...state, loading: true };

        case BILLING_ADDRESSES_SUCCESS:
            return { ...state, loading: false, data: action.payload };

        case BILLING_ADDRESSES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default: return { ...state };
    }
}
